import { Presentation } from "lucide-react";

const ServiceTileDesign = {
  id: "service",
  icon: Presentation,
  label: "Service",
  background: "#5F7D4D",
  color: "#ffffff",
};

export default ServiceTileDesign;
